import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES, ASSETS } from "../../data/content";

export const Services = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="services" className="relative py-24 md:py-40 border-t border-brand-line bg-brand-surface/40" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <p className="overline mb-6">02 — What we do</p>
            <h2 className="font-display font-light text-4xl md:text-6xl lg:text-7xl tracking-tight text-brand-text leading-[1.02]">
              Eight disciplines,<br />one standard.
            </h2>
          </div>
          <p className="max-w-xs text-brand-soft font-light">
            Integrated services spanning consultancy, capacity building, resourcing and security management.
          </p>
        </Reveal>

        {/* Floating preview image for desktop hover */}
        <div className="relative">
          <div className="hidden lg:block pointer-events-none fixed z-30" />
          <div className="border-t border-brand-line">
            {SERVICES.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.05}>
                <div
                  onMouseEnter={() => setActive(i)}
                  onMouseLeave={() => setActive(null)}
                  data-testid={`service-row-${s.n}`}
                  className="group relative grid grid-cols-[auto_1fr_auto] md:grid-cols-[auto_0.9fr_1.1fr_auto] items-center gap-4 md:gap-8 py-7 md:py-9 border-b border-brand-line cursor-default"
                >
                  <span className="font-mono text-xs text-brand-muted">{s.n}</span>
                  <h3 className="font-display text-2xl md:text-4xl lg:text-5xl font-light text-brand-text group-hover:text-brand group-hover:translate-x-2 transition-all duration-500">
                    {s.title}
                  </h3>
                  <p className="hidden md:block text-brand-soft font-light max-w-md opacity-70 group-hover:opacity-100 transition-opacity duration-500">
                    {s.desc}
                  </p>
                  <ArrowUpRight
                    size={22}
                    className="text-brand-muted group-hover:text-brand group-hover:rotate-45 transition-all duration-500 justify-self-end"
                  />

                  {/* Clipped image reveal (desktop) */}
                  <AnimatePresence>
                    {active === i && (
                      <motion.div
                        initial={{ opacity: 0, scale: 0.85, x: 20 }}
                        animate={{ opacity: 1, scale: 1, x: 0 }}
                        exit={{ opacity: 0, scale: 0.9 }}
                        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                        className="hidden lg:block absolute right-16 top-1/2 -translate-y-1/2 w-56 h-36 overflow-hidden z-20 pointer-events-none border border-brand-line"
                      >
                        <img src={ASSETS[s.img]} alt="" className="w-full h-full object-cover grayscale" />
                        <div className="absolute inset-0 bg-brand/20 mix-blend-multiply" />
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
